<app-case-medical [processingClassSubtype]="processingClassSubType.Pharmacy"></app-case-medical>
